module.exports = __webpack_public_path__ + "static/media/back-icon.8c736b0e.svg";